// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2SpPp","modalForm":"UpgradeEpcsModal_modalForm__3XXZJ","modalFooter":"UpgradeEpcsModal_modalFooter__3dP8b"};